import React from 'react'

const LikeIcon: React.FC<{ className: string }> = ({ className }) => (
  <svg
    className={className}
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9391 0.962154C13.095 0.393917 13.6115 0 14.2007 0C15.7112 0 17.2811 0.792871 18.1476 2.57605C18.8378 3.99658 19.0304 5.93233 18.587 8.4316H23.5021C25.252 8.4316 26.5087 10.1162 26.01 11.7935L22.3906 23.9689C22.0324 25.1738 20.9248 26 19.6678 26H14.612C11.8439 26 9.14761 25.2311 6.81418 23.8022C6.61383 25.0482 5.53363 26 4.23113 26H1.30818C0.58569 26 0 25.4143 0 24.6918C0 23.9693 0.58569 23.3836 1.30818 23.3836H4.23113V8.01258H1.30818C0.58569 8.01258 0 7.42689 0 6.7044C0 5.98192 0.58569 5.39623 1.30818 5.39623H4.23113C5.6761 5.39623 6.84748 6.56761 6.84748 8.01258V8.82491C8.34969 8.52822 9.57194 7.97655 10.2927 7.0199C11.3767 5.58101 12.213 3.60967 12.9391 0.962154ZM6.84748 11.4784V20.6277C9.03905 22.4078 11.78 23.3836 14.612 23.3836H19.6678C19.767 23.3836 19.8544 23.3184 19.8827 23.2234L23.5021 11.048H16.9775C16.3903 11.048 15.8934 10.6611 15.728 10.1283C15.6488 9.89491 15.6346 9.63658 15.7012 9.38025C16.4815 6.37606 16.239 4.63475 15.7943 3.71954C15.6022 3.32421 15.3615 3.0571 15.103 2.88487C14.4035 5.13212 13.5468 7.04865 12.3823 8.59425C11.0027 10.4254 8.83023 11.1475 6.95588 11.4647C6.91963 11.4708 6.88347 11.4754 6.84748 11.4784Z"
    />
  </svg>
)

export default LikeIcon
